import {
  SHOW_DELETE_CONFIRMATION_MODAL,
  HIDE_DELETE_CONFIRMATION_MODAL,
  SET_CONTENT_NAME,
  SET_DELETE_CALLBACK,
  SET_CONTENT_TYPE,
  SET_CANCEL_CALLBACK,
} from '../constants';

const initialState = {
  show: false,
  contentName: '',
  contentType: '',
  deleteCallback: () => {},
  cancelCollback: () => {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_DELETE_CONFIRMATION_MODAL:
      return { ...state, show: action.payload };
    case HIDE_DELETE_CONFIRMATION_MODAL:
      return { ...state, show: action.payload };
    case SET_CONTENT_NAME:
      return { ...state, contentName: action.payload };
    case SET_CONTENT_TYPE:
      return { ...state, contentType: action.payload };
    case SET_DELETE_CALLBACK:
      return { ...state, deleteCallback: action.payload };
    case SET_CANCEL_CALLBACK:
      return { ...state, cancelCollback: action.payload };
    default:
      return state;
  }
};
